import {RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';

const routes: Routes = [];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {useHash: true})
